(function ManagerClientForm($, HE, tinymce)
{
	"use strict";

	var form = {
		name: 'Client',
	};

	$(document).ready(function documentReady()
	{
		HE.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		let colorInputs  = $('.color-selector-section input.choose-color');
		let colorValues  = {};
		let $sortButton  = $('.sort-button-option');
		let $savingsTag  = $('.savings-tag-option');
		let $selectHotel = $('.select-hotel-button-option');
		let $selectRoom  = $('.select-room-button-option');
		let $resetButton = $('.reset-field');

		_setFields();
		_initPreviews('sort-button', '.preview');

		colorInputs.each(function createColorpickers() {
			let inputId = $(this).attr('id');
			let val     = $(this).val();
			$("#"+inputId).spectrum({
				color          : val,
				preferredFormat: 'hex',
				showInitial    : true,
				showInput      : true,
				change         : function changeColor(color) {
					var modifiedColor = color.toHexString().toUpperCase();
					$("#"+inputId).val(modifiedColor);
				}
			});
		});


		dragula([$('table.providers tbody')[0]], {
			revertOnSpill: true,
		})
		.on('drop', function sortProviders(this_el, target, source, sibling) {
			$('table.providers tr.provider').each(function _updateSortOrder(i, el) {
				$(el).find('[id^="client-provider-fallback_order"]').val(i + 1);
			});
		});

		$("[class*='-preview']").on('click', function preventClick(e) {
			e.preventDefault();
		});

		$('#client-allow_markup').click(function _toggleMarkupPercentages() {
			 if ($(this).prop('checked') === true) {
				$('#client-markup_low').prop('disabled', false);
				$('#client-markup_high').prop('disabled', false);
				$('#client-markup_admin_fee_percentage').prop('disabled', false);

			 } else {
				$('#client-markup_low').prop('disabled', true);
				$('#client-markup_high').prop('disabled', true);
				$('#client-markup_admin_fee_percentage').prop('disabled', true);
			 }
		});

		$('#client-feature_specialty_rates').on('click', function _toggleNumSpecialtyRates() {
			if ($(this).prop('checked') === true) {
				$('.featured-fields').removeClass('d-none');
			} else {
				$('.featured-fields').addClass('d-none');
			}
		});

		$('#client-pay_later_active').click(function showPaySection(e) {
			let $paymentBuffer = $('#client-payment_window_buffer');

			if ($(this).prop('checked') === true) {
				$('.pay_later_section').removeClass('d-none');
				$paymentBuffer.attr('required', true);
				$('label[for="client-payment_window_buffer"]').addClass('required');
				_determineDepositType();
			} else {
				$('.pay_later_section').addClass('d-none');
				$paymentBuffer.attr('required', false);
				$('label[for="client-payment_window_buffer"]').removeClass('required');

				$('.pay_later_section  input, .pay_later_section select ').each(function clearValues() {
					$(this).val('');
				});
			}
		});


		$sortButton.on('change', function sortPreview() {
			let value   = $(this).val();
			let classes = $(this).attr('class').split(/\s+/);
			console.log(classes);
			switch (classes[1]) {
				case 'sort-button-color':
					colorValues['background-color'] = value + ' !important';
					break;
				case 'sort-button-text-color':
					colorValues['color'] = value + ' !important';
					break;
				case 'sort-button-border-color':
					colorValues['border-color'] = value + ' !important';
					break;
				default:
					break;
			}


			let inlineStyles = Object.entries(colorValues)
				.map(([key, value]) => `${key}: ${value}`)
				.join('; ');

			$('.sort-button-preview').attr('style', inlineStyles);

		});

		$savingsTag.on('change', function sortPreview() {
			let el;
			let value   = $(this).val();
			let classes = $(this).attr('class').split(/\s+/);

			switch (classes[1]) {
				case 'savings-tag-color':
					colorValues  = {};
					colorValues['background-color'] = value + ' !important';
					el = 'clip';
					break;
				case 'savings-tag-text-color':
					colorValues  = {};
					colorValues['color'] = value + ' !important';
					el = 'clip-price';
					break;
				default:
					break;
			}

			let inlineStyles = Object.entries(colorValues)
				.map(([key, value]) => `${key}: ${value}`)
				.join('; ');

			$('.'+ el).attr('style', inlineStyles);

		});

		$('.savings-tag-badge-label').on('change', function changeSavingsLabel() {
			let value = $(this).val();
			$('#savings-label-text').html(value.toUpperCase());
		});

		$('.savings-tag-value-format').on('click', function changeSavingType() {
			let value = $(this).val();
			console.log(value, 'saving');
			if (value === 'percent') {
				$('#savings-value-format').html('15%');
			} else {
				$('#savings-value-format').html('$20');
			}
		});

		$selectHotel.on('change', function sortPreview() {
			let value   = $(this).val();
			let classes = $(this).attr('class').split(/\s+/);

			switch (classes[1]) {
				case 'select-hotel-color':
					colorValues['background-color'] = value + ' !important';
					break;
				case 'select-hotel-text-color':
					colorValues['color'] = value + ' !important';
					break;
				case 'select-hotel-border-color':
					colorValues['border-color'] = value + ' !important';
					break;
				default:
					break;
			}


			let inlineStyles = Object.entries(colorValues)
				.map(([key, value]) => `${key}: ${value}`)
				.join('; ');

			$('.select-hotel-button-preview').attr('style', inlineStyles);

		});

		$selectRoom.on('change', function sortPreview() {
			let value   = $(this).val();
			let classes = $(this).attr('class').split(/\s+/);

			switch (classes[1]) {
				case 'select-room-color':
					colorValues['background-color'] = value + ' !important';
					break;
				case 'select-room-text-color':
					colorValues['color'] = value + ' !important';
					break;
				case 'select-room-border-color':
					colorValues['border-color'] = value + ' !important';
					break;
				default:
					break;
			}


			let inlineStyles = Object.entries(colorValues)
				.map(([key, value]) => `${key}: ${value}`)
				.join('; ');

			$('.select-room-button-preview').attr('style', inlineStyles);

		});

		$resetButton.on('click', function resetFields(e) {
			e.preventDefault();
			const client_id = $('#client-id').val();
			let data        = {};
			let classes     = $(this).attr('class').split(/\s+/);
			let section     = classes[1].replace('-reset', '');
			let preview     = section + '-preview';
			let option      = section + '-option';

			data.client_id = client_id;
			console.log(classes);

			switch (classes[1]) {
				case 'search-header-reset':
					data.fields = ['search_header_color'];
					break;
				case 'filter-header-reset':
					data.fields = ['filter_header_color'];
					break;
				case 'sort-button-reset':
					data.fields = [
						'sort_button_color',
						'sort_button_text_color',
						'sort_button_border_color'
					];
					break;
				case 'savings-tag-reset':
					data.fields = [
						'savings_tags_color',
						'savings_tags_text_color',
					];

					break;
				case 'select-hotel-button-reset':
					data.fields = [
						'select_hotel_button_color',
						'select_hotel_button_text_color',
						'select_hotel_button_border_color'
					];
					break;
				case 'select-room-button-reset':
					data.fields = [
						'select_room_button_color',
						'select_room_button_text_color',
						'select_room_button_border_color'
					];
					break;
				default:
					data.fields = [];
					break;
			}


			HE.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to reset the colors for this element?',
				confirm: function confirm() {
					HE.Ajax.post('/Clients/resetUiColors', data)
						.then(function _resetFields(success) {
							if (preview === 'savings-tag-preview') {
								$('.clip').removeAttr('style');
								$('.clip-price').removeAttr('style');
							} else {
								$('.' + preview).removeAttr('style');
							}

							$('.' + option).siblings('.sp-replacer').find('.sp-preview-inner').attr('style', '');
							$('.' + option).val('');

							// document.location = HE.base_uri + '/Clients/edit/' + client_id;
						});
				}
			});


		});
	};

	function _setFields() {
		let payLaterActive = $('#client-pay_later_active').val();

		if (payLaterActive) {
			_determineDepositType();
		}

	}

	function _determineDepositType() {
		let $paymentBuffer = $('#client-payment_window_buffer');
		let $finalPayment  = $('#client-final_payment_date');

		$paymentBuffer.attr('required', true);
		$('label[for="client-payment_window_buffer"]').addClass('required');

		if ($paymentBuffer.val() === '' || $paymentBuffer.val() === undefined || $paymentBuffer.val() === null) {
			$paymentBuffer.val(2);
		}

		if ($finalPayment.val() === '' || $finalPayment.val() === undefined || $finalPayment.val() === null ) {
			$finalPayment.val(30);
		}

	}

	function _initPreviews() {
		let colorValues  = {};
		let savingsText  = $('.savings-tag-badge-label').val();
		let savingsFormat = $('.savings-tag-value-format:checked').val();

		$('#savings-label-text').html(savingsText.toUpperCase());
		console.log(savingsFormat, 'Savings Format');
		if (savingsFormat === 'percent') {
			$('#savings-value-format').html('15%');
		} else {
			$('#savings-value-format').html('$20');
		}

		// Object containing element data
		let elementData = {
			sort: {
				prefix  : 'sort-button',
				preview : 'sort-button-preview',
				elements: {
					'client-sort_button_color': {
						classes: $('#client-sort_button_color').attr('class').split(/\s+/),
						value  : $('#client-sort_button_color').val(),
					},
					'client-sort_button_text_color': {
						classes: $('#client-sort_button_text_color').attr('class').split(/\s+/),
						value  : $('#client-sort_button_text_color').val(),
					},
					'client-sort_button_border_color': {
						classes: $('#client-sort_button_border_color').attr('class').split(/\s+/),
						value  : $('#client-sort_button_border_color').val(),
					},
				},
			},
			'select-hotel': {
				prefix  : 'select-hotel',
				preview : 'select-hotel-button-preview',
				elements: {
					'client-select_hotel_button_color': {
						classes: $('#client-select_hotel_button_color').attr('class').split(/\s+/),
						value  : $('#client-select_hotel_button_color').val(),
					},
					'client-select_hotel_button_text_color': {
						classes: $('#client-select_hotel_button_text_color').attr('class').split(/\s+/),
						value  : $('#client-select_hotel_button_text_color').val(),
					},
					'client-select_hotel_button_border_color': {
						classes: $('#client-select_hotel_button_border_color').attr('class').split(/\s+/),
						value  : $('#client-select_hotel_button_border_color').val(),
					},
				},
			},
			'select-room': {
				prefix  : 'select-room',
				preview : 'select-room-button-preview',
				elements: {
					'client-select_room_button_color': {
						classes: $('#client-select_room_button_color').attr('class').split(/\s+/),
						value  : $('#client-select_room_button_color').val(),
					},
					'client-select_room_button_text_color': {
						classes: $('#client-select_room_button_text_color').attr('class').split(/\s+/),
						value  : $('#client-select_room_button_text_color').val(),
					},
					'client-select_room_button_border_color': {
						classes: $('#client-select_room_button_border_color').attr('class').split(/\s+/),
						value  : $('#client-select_room_button_border_color').val(),
					},
				},
			},
			clip: {
				prefix  : 'savings-tag',
				preview : 'clip',
				elements: {
					'client-savings_tags_color': {
						classes: $('#client-savings_tags_color').attr('class').split(/\s+/),
						value  : $('#client-savings_tags_color').val(),
					},
				}
			},
			'clip-price': {
				prefix  : 'savings-tag',
				preview : 'clip-price',
				elements: {
					'client-savings_tags_text_color': {
						classes: $('#client-savings_tags_text_color').attr('class').split(/\s+/),
						value  : $('#client-savings_tags_text_color').val(),
					},
				}
			}
		};


		$.each(elementData, function setClasses(key, eData) {
			let prefix  = eData.prefix;  // Array of classes
			let preview = eData.preview;

			// Loop through elementData
			$.each(eData.elements, function setClasses(key, data) {
				let classes = data.classes;  // Array of classes
				let value   = data.value;      // Value (color or style value)

				// Loop through each class and apply switch logic
				classes.forEach(function classSwitch(cls) {
					switch (cls) {
						case prefix + '-color':
							colorValues['background-color'] = value + ' !important';
							break;
						case prefix + '-text-color':
							colorValues['color'] = value + ' !important';
							break;
						case prefix + '-border-color':
							colorValues['border-color'] = value + ' !important';
							break;
						default:
							break;
					}
				});
			});

			// Generate inline styles from colorValues
			let inlineStyles = Object.entries(colorValues)
				.map(([key, value]) => `${key}: ${value}`)
				.join('; ');

			colorValues = {};

			// Apply inline styles to the previewClass element
			$('.'+preview).attr('style', inlineStyles);

		});


	}


}(jQuery, window.HE || {}));
